{
  "feedback-process-pages": {
    "feedback-process-steps": {
      "step-1": {
        "title": "Votre satisfaction",
        "description": "Êtes-vous satisfait de notre service ?"
      },
      "step-2": {
        "title": "Votre avis",
        "description": "Écrivez vos commentaires"
      },
      "step-3": {
        "title": "Feedback envoyé",
        "description": "Votre retour d'information est envoyé"
      }
    },
    "meta": {
      "title": "Retour d'information",
      "description": "Votre avis"
    }
  }
}
